// extracted by mini-css-extract-plugin
export default {"header__socials":"HeaderSocial_header__socials__5WJEM"};